import React from 'react';
import { Row } from 'reactstrap';
import ToggleContainer from '../../../Sidebar/FilterOptions/TextSearchCollapser/SearchToggles/ToggleContainer';
import ViewInactivePluginsToggle from './FilterToggles/ViewInactivePluginsToggle';

const FilterPluginToggles = () => {
    return (
        <Row>
            <ToggleContainer toggle={ViewInactivePluginsToggle} />
        </Row>
    );
};

export default FilterPluginToggles;